import {
  RECEIVE_PAGE,
  RECEIVE_PAGE_INDEX,
  REMOVE_PAGE_INDEX,
  RECEIVE_VERSION,
  RECEIVE_CONTENT
} from '../../constants';

import debugSetup from 'debug';
const debug = debugSetup('kiwi:reducers:pages');


const initialState = {
  /**
   * Contains pageId strings
   */
  index: [],

  pageById: {
    'abc123': {
      versionId: 1
    }
  },

  versionById: {
    1: {
      title: 'My Static Title'
    }
  },

  contentByVersionId: {
    1: {
      content: 'My favorite content'
    },

    2: {
      type: 'RawDraftContentState',
      payload: '...draft-js format'
    }
  }
}

export default function pages(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_PAGE:
      return {
        ...state,
        pageById: {
          ...state.pageById,
          [action.key]: action.value
        }
      }
    case RECEIVE_PAGE_INDEX:
      const next = {
        ...state,
        pageById: {
          ...state.pageById,
          [action.key]: action.value
        }
      };

      if (next.index.indexOf(action.key) === -1) {
        return {
          ...next,
          index: [...state.index, action.key]
        }
      } else {
        return next;
      }
    case REMOVE_PAGE_INDEX:
      return {
        ...state,
        index: state.index.filter(key => key !== action.key)
      }
    case RECEIVE_VERSION:
      return {
        ...state,
        versionById: {
          ...state.versionById,
          [action.key]: action.value
        }
      }
    case RECEIVE_CONTENT:
      return {
        ...state,
        contentByVersionId: {
          ...state.contentByVersionId,
          [action.key]: action.value
        }
      }
    default:
      return state;
  }
}

/**
 * Returns the latest title by pageId
 */
export function getTitle(state, pageId) {
  const page = state.pageById[pageId];

  // Guard no page
  if (!page) {
    return;
  }

  const versionId = page.versionId;
  const version = state.versionById[versionId];

  // Guard no version
  if (!version) {
    return;
  }

  return version.title;
}

/**
 * Return the latest content by pageId (ContentState)
 */
export function getContent(state, pageId) {
  const page = state.pageById[pageId];

  // Guard page not loaded yet
  if (!page) {
    return;
  }

  const versionId = page.versionId;
  const content = state.contentByVersionId[versionId];

  // Guard content not loaded yet
  if (!content) {
    return;
  }

  // Only support rich content now
  if (!isRichContent(content)) {
    debug(`non-rich content found. Should be upgraded or removed.`);
    return;
  }

  return getContentState(content);
}

/**
 * Returns true if the content is RawDraftContentState
 */
function isRichContent(content) {
  return content.type === 'RawDraftContentState';
}

import {convertToRaw, convertFromRaw} from 'draft-js';

/**
 * Takes a draft.js ContentState and converts to a JSON object
 */
export function createContent(content) {
  return {
    type: 'RawDraftContentState',
    payload: JSON.stringify(convertToRaw(content))
  }
}

function getContentState(content) {
  if (!isRichContent(content)) {
    throw new Error('not rich content');
  }

  return convertFromRaw(JSON.parse(content.payload));
}

/**
 * Returns an array of page objects by mapping ids to the cached page objects
 *
 * Schema: {id: string, title: string}
 */
export function getPageIndex(state) {
  return state.index.map(pageId => {
    return {
      id: pageId,
      title: getTitle(state, pageId)
    }
  });
}


/** WEBPACK FOOTER **
 ** ./src/store/reducers/pages.js
 **/